import {BlueshiftIcon} from "../../components/icon/BlueshiftIcon.tsx";
import type {Flavor, Instance, Snapshot} from "../../lib/ModelTypes.ts";
import React from "react";
import {formattedDate, replaceName} from "../../util/ReplaceText.tsx";
import {useTranslation} from "react-i18next";

type SnapshotListProps = {
    data: Snapshot[]
    instances: Instance[]
    flavor: Flavor[]
};

const SnapshotList = React.memo(({data, instances, flavor}: SnapshotListProps) => {
    const {t} = useTranslation("ui");

    const snapshotElement = (name: string, date: string, index: number) => {
        const isUnused = name === t("snapshot.unused");
        return <div key={name + "_" + index} className="col-3" style={{color: isUnused ? "#585757" : "#264EDD"}}>
            <BlueshiftIcon.Snapshot/>
            <h5 className="my-3">  {isUnused ? t("dashboard.unused") : replaceName(name)}</h5>
            <h5 className="my-3">  {isUnused ? "" : `${t("dashboard.createdAt")}: ${formattedDate(date)}`}</h5>
        </div>
    }
    const elements: JSX.Element[] = [];

    for (let index = 0; index < 2; index++) {
        if (data[(index)] === undefined) {
            elements.push(
                snapshotElement(t("snapshot.unused"), "", index)
            );
        } else {
            instances.forEach((instance) => {
                if (data[(index)].server_id === instance.id) {
                    const matched = flavor.find(flavor => instance.flavor.id === flavor.id);
                    if (matched) {
                        elements.push(
                            snapshotElement(matched.name, data[(index)].created, index)
                        );
                    }
                }
            });
        }
    }


    return elements;
})


export default SnapshotList;